import './_subscribe-options.scss'

const purchaseOptionsTypeButtons = document.querySelectorAll('input[name="purchase-option"]')
if (purchaseOptionsTypeButtons.length) {
  for (let i = 0; i < purchaseOptionsTypeButtons.length; i++) {
    purchaseOptionsTypeButtons[i].addEventListener('click', (e) => {
      const subscribeOptions = document.querySelector('.subscribe-options')
      const oneTimeOptions = document.querySelector('.one-time-options')
      switch(e.target.value) {
        case 'one-time':
          subscribeOptions.classList.add('hide')
          oneTimeOptions.classList.remove('hide')
          break;
        case 'subscribe':
          subscribeOptions.classList.remove('hide')
          oneTimeOptions.classList.add('hide')
          break;
        default:
          break;
      }
    })
  }
}
